import { Navigate, Outlet, useLocation } from "react-router-dom";
import { useAuthContext } from "../_helper/Auth";
import { useEffect } from "react";
import { SomethingWentWrong } from "../CommonElements/SomthingWentWrong";
import { ClientCache } from "../Pages/ClientCache";
import { saveRedirectPath } from "../utils/redirectStore";

/** Allowed while password_change_required is true (must match app route). */
export const MANDATORY_CHANGE_PASSWORD_PATH = "/app/me/change-password";

const PrivateRoutes = () => {
  const {
    token: login,
    updateUser,
    isInternelServerError,
    emailVerificationPending,
    passwordChangeRequired,
  } = useAuthContext();
  const location = useLocation();
  const { pathname, search } = location;

  const user = localStorage.getItem("user");

  useEffect(() => {
    if (!!login && !user) {
      updateUser();
    }
  }, [user, login]);

  if (!user) {
    saveRedirectPath(pathname, search, location.hash);
    return (
      <Navigate
        to={"/login"}
        state={{
          from: {
            pathname,
            search,
            hash: location.hash,
          },
        }}
        replace
      />
    );
  }

  if (
    passwordChangeRequired &&
    pathname !== MANDATORY_CHANGE_PASSWORD_PATH
  ) {
    return (
      <Navigate to={MANDATORY_CHANGE_PASSWORD_PATH} replace />
    );
  }

  if (emailVerificationPending) {
    return <Navigate to="/verify-email" replace />;
  }

  return isInternelServerError ? (
    <SomethingWentWrong />
  ) : (
    <Outlet />
  );
};

export default PrivateRoutes;
